import React, { Component } from 'react'
import './Right_side.css'
import Checkbox from './Checkbox';
import CheckboxTeacher from './CheckboxTeacher';


export default class Right_side extends Component {
    constructor(props) {
        super(props);
        this.state = {
            primechanie: 0,
            id_rate: this.props.id_rate,
            SureDel: -1,
            updateWindow: -1,
            Description: [],
            DescriptionTeacher: [],
            warning_raion: 0,
            redactRaion: 0,
            plusraion: 0,
            activerow: 0,
            Checkbox_clicked: false,
            newRaion: null,
            newRaionKg: null,
            activerow_ind: null
        }
    }

    componentDidMount() {
        const { Description, DescriptionTeacher } = this.props
        this.setState({
            id_rate: this.props.id_rate,
            Description: Description,
            DescriptionTeacher: DescriptionTeacher
        })
        this.selectedCheckboxes = new Set();
        this.selectedCheckboxesTeacher = new Set();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.id_student !== this.props.id_student) {
            this.setState({ id_rate: this.props.id_rate })
            this.selectedCheckboxes = new Set();
            setTimeout(() => {
                const s = this.props.Properties.map(item => item.dolg === true ? item.okno_pole : null)
                s.map(item => this.toggleCheckbox(item))
            }, 200);
            this.setState({
                Checkbox_clicked: false
            })
        }
        if (prevProps.id_teacher !== this.props.id_teacher) {
            this.selectedCheckboxesTeacher = new Set();
            setTimeout(() => {
                const t = this.props.PropertiesTeacher.map(item => item.dolg === true ? item.okno_pole : null)
                t.map(item => this.toggleCheckboxTeacher(item))
            }, 200);
            this.setState({
                Checkbox_clicked: false
            })
        }
        if (this.state.Description !== this.props.Description) {
            this.setState({ Description: this.props.Description, })
        }
        if (this.state.DescriptionTeacher !== this.props.DescriptionTeacher) {
            this.setState({ DescriptionTeacher: this.props.DescriptionTeacher, })
        }
    }
    /*-----StudentChekboxSetiings-------*/


    toggleCheckbox = (label) => {
        if (this.selectedCheckboxes.has(label)) {
            this.selectedCheckboxes.delete(label);
        } else {
            this.selectedCheckboxes.add(label);
        }
    }
    handleFormSubmit = formSubmitEvent => {
        formSubmitEvent.preventDefault();
        const Sltd_Okno_Pole = this.props.Properties.map((item) => this.selectedCheckboxes.has(item.okno_pole) ? 1 : 0)
        // console.log(this.selectedCheckboxes, "this.selectedCheckboxes")
        // console.log(Sltd_Okno_Pole, "Sltd_Okno_Pole")
        this.postPropertiesInsertUpdate(
            Sltd_Okno_Pole[0],
            Sltd_Okno_Pole[1],
            Sltd_Okno_Pole[2],
            Sltd_Okno_Pole[3],
            Sltd_Okno_Pole[4],
            Sltd_Okno_Pole[5],
            Sltd_Okno_Pole[6],
            Sltd_Okno_Pole[7],
            Sltd_Okno_Pole[8],
            Sltd_Okno_Pole[9])
        // Sltd_Okno_Pole.map(item=>this.postPropertiesInsertUpdate(item))

    }
    createCheckbox = (okno_title, okno_pole, dolg, visibles, visibility) => (
        <Checkbox
            ChekedControl={this.ChekedControl.bind(this)}
            id_student={this.props.id_student}
            label={okno_pole}
            title={okno_title}
            dolg={dolg}
            Payment={this.props.PAYMENT}
            visibles={visibles}
            visibility={visibility}
            handleCheckboxChange={this.toggleCheckbox}
            key={okno_pole}
        />
    )
    createCheckboxes = () => (
        (this.props.Properties && this.props.Properties.length > 0 ?
            this.props.Properties.map((item) => {
                return this.createCheckbox(item.okno_title, item.okno_pole, item.dolg, item.visibles, item.visibility)
            }) : null)
    )
    postPropertiesInsertUpdate = (ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3) => {
        this.props.postPropertiesInsertUpdate(ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3)
    }
    onChangeDescription(event) {
        this.props.onChangeDescription(event)
    }
    postDescriptionInsert() {
        this.props.postDescriptionInsert()
        this.OpenPrimechanie(0)
    }
    postDescriptionUpdate(id_okno_description) {
        this.props.postDescriptionUpdate(id_okno_description)
        this.OpenUpdateWindow(-1)
    }
    postDescriptionDelete(id_okno_description) {
        this.props.postDescriptionDelete(id_okno_description)
        this.sureDelete(-1)
    }

    /*-----TeacherChekboxSetiings-------*/

    toggleCheckboxTeacher = (label) => {
        if (this.selectedCheckboxesTeacher.has(label)) {
            this.selectedCheckboxesTeacher.delete(label);
        } else {
            this.selectedCheckboxesTeacher.add(label);
        }
    }
    handleFormSubmitTeacher = formSubmitEvent => {
        formSubmitEvent.preventDefault();
        const Sltd_Okno_Pole_Teacher = this.props.PropertiesTeacher.map((item) => this.selectedCheckboxesTeacher.has(item.okno_pole) ? 1 : 0)
        // console.log(this.selectedCheckboxesTeacher, "this.selectedCheckboxesTeacher")
        // console.log("PropertiesTeacher", this.props.PropertiesTeacher.map(item => item.dolg))
        // console.log(Sltd_Okno_Pole_Teacher, "Sltd_Okno_Pole_Teacher")
        this.postTeacherPropertiesInsertUpdate(
            Sltd_Okno_Pole_Teacher[0],
            Sltd_Okno_Pole_Teacher[1],
            Sltd_Okno_Pole_Teacher[2],
            Sltd_Okno_Pole_Teacher[3],
            Sltd_Okno_Pole_Teacher[4],
            Sltd_Okno_Pole_Teacher[5],
            Sltd_Okno_Pole_Teacher[6],
            Sltd_Okno_Pole_Teacher[7])

    }
    createCheckboxTeacher = (okno_title, okno_pole, dolg, visibles, visibility) => (
        <CheckboxTeacher
            ChekedControl={this.ChekedControl.bind(this)}
            id_teacher={this.props.id_teacher}
            okno_pole={okno_pole}
            title={okno_title}
            dolg={dolg}
            visibles={visibles}
            visibility={visibility}
            handleCheckboxChangeTeacher={this.toggleCheckboxTeacher}
            key={okno_pole}
        />
    )
    createCheckboxesTeacher = () => (
        (this.props.PropertiesTeacher && this.props.PropertiesTeacher.length > 0 ?
            this.props.PropertiesTeacher.map((item) => {
                return this.createCheckboxTeacher(item.okno_title, item.okno_pole, item.dolg, item.visibles, item.visibility)
            }) : null)
    )

    postTeacherPropertiesInsertUpdate = (t_fio_pole1, t_fio_pole2, t_fio_pole3, t_fio_pole4, t_fio_pole5, t_fio_pole6, t_fio_pole7, t_fio_pole8) => {
        this.props.postTeacherPropertiesInsertUpdate(t_fio_pole1, t_fio_pole2, t_fio_pole3, t_fio_pole4, t_fio_pole5, t_fio_pole6, t_fio_pole7, t_fio_pole8, 0)
    }
    onChangeDescriptionTeacher(event) {
        this.props.onChangeDescriptionTeacher(event)
    }
    postDescriptionTeacherInsert() {
        this.props.postDescriptionTeacherInsert()
        this.OpenPrimechanie(0)
    }
    postDescriptionTeacherUpdate(id_okno_description_teacher) {
        this.props.postDescriptionTeacherUpdate(id_okno_description_teacher)
        this.OpenUpdateWindow(-1)
    }
    postDescriptionTeacherDelete(id_okno_description_teacher) {
        this.props.postDescriptionTeacherDelete(id_okno_description_teacher)
        this.sureDelete(-1)
    }
    ChekedControl = () => {
        this.setState({ Checkbox_clicked: true })
    }
    /*----END-TeacherChekboxSetiings-------*/

    saveProperties() {
        this.setState({})
    }
    OpenPrimechanie = (primechanie) => {
        this.setState({ primechanie })
    }
    OpenUpdateWindow(updateWindow) {
        this.setState({ updateWindow })
    }
    sureDelete(SureDel) {
        this.setState({ SureDel })
    }
    SelectRepublic(e) {
        this.props.SelectRepublic(e)
    }
    SelectOblast(e) {
        this.props.SelectOblast(e)
    }
    SelectRaion(e) {
        this.props.SelectRaion(e)
    }

    /*-------------------Student Reports--------------------*/
    OpenSpravka = (spravka) => {
        this.props.OpenSpravka(spravka)
    }
    OpenReportsPage = (reportsPage, reportType) => {
        if ((reportType === 2 || reportType === 3) && this.props.id_raion < 1) {
            this.warning(1)
        } else {
            this.props.OpenReportsPage(reportsPage, reportType)
        }
    }
    warning(warning_raion) {
        this.setState({ warning_raion })
    }
    postObhodnoiList(id_group, id_student, id_protocols) {
        this.props.postObhodnoiList(id_group, id_student, id_protocols)
    }
    postVoenKom(id_group, id_student, id_raion, id_faculty, login, password) {
        this.props.postVoenKom(id_group, id_student, id_raion, id_faculty, login, password)
    }
    openRedactWindowRaion(redactRaion) {
        this.setState({ redactRaion })
        if (this.state.redactRaion === 0) {
            this.OpenSpravka(0)
        } else {
            this.OpenSpravka(1)
        }
    }
    activeUpdateRow(activerow, activerow_ind) {
        this.setState({ activerow, activerow_ind })
        if (this.state.activerow === 0) {
            this.setState({
                newRaion: null,
                newRaionKg: null,
                activerow_ind: null
            })
        }
    }
    plusInsertRow(plusraion) {
        this.setState({ plusraion })
        if (this.state.plusraion === 0) {
            this.setState({
                newRaion: null,
                newRaionKg: null
            })
        }
    }

    onChangeRaion = (e) => {
        this.setState({ newRaion: e.target.value })
    }
    onChangeRaionKg = (e) => {
        this.setState({ newRaionKg: e.target.value })
    }

    SaveUpdatedRaion(index, id_raion) {
        this.postUpdateRaion(index, id_raion, this.props.id_oblast, this.state.newRaion, this.state.newRaionKg)
        setTimeout(() => {
            this.setState({
                newRaion: null,
                newRaionKg: null,
                activerow: 0,
                index: null,
                activerow_ind: null
            })
        }, 30);
    }
    SaveInsertedRaion() {
        this.postInsertRaion(this.props.id_oblast, this.state.newRaion, this.state.newRaionKg)
        setTimeout(() => {
            this.setState({
                newRaion: null,
                newRaionKg: null,
                plusraion: 0
            })
        }, 30);
    }
    SureDeleteRaion(id_raion) {
        this.props.postDeleteRaion(id_raion)
    }
    postUpdateRaion(index, id_raion, id_oblast, newRaion, newRaionKg) {
        { }
        this.props.postUpdateRaion(index, id_raion, id_oblast, newRaion, newRaionKg)
    }
    postInsertRaion(id_oblast, newRaion, newRaionKg) {
        this.props.postInsertRaion(id_oblast, newRaion, newRaionKg)
    }
    postDeleteRaion() {
        this.props.postDeleteRaion()
    }



    render() {
        const { photo, StudentInf, Republics, OblastList, RaionList, teacherPhoto, PAYMENT } = this.props
        const { Description, DescriptionTeacher, newRaion, newRaionKg } = this.state
        if (StudentInf && StudentInf == null) return null

        else
            return (
                this.props.selected_menu === 1
                    // || this.props.selected_menu === 3 
                    ?
                    // студент_студент_студент_студент_студент_студент_студент_студент_студент_студент_студент_студент
                    <div className="Right_side_container">
                        <div className={this.props.id_student > 0 ? 'About_person' : 'About_person Notactive'}>
                            <div className='Ava_person'
                                style={{ border: this.props.id_student > 0 ? 'none' : '1px solid #2F80ED' }}>
                                {this.props.id_student > 0 ?
                                    photo && photo.length > 0 ? <img src={`data:image/jpeg;base64,${photo}`} alt='Avatar' /> :
                                        <i className="fas fa-user-graduate"></i> : null
                                }
                            </div>
                            <div className='Fio_person'>
                                <h3>{StudentInf && StudentInf.length > 0 ? StudentInf[0].s_fio : 'ФИО'}</h3>
                                <p>{StudentInf && StudentInf.length > 0 ? StudentInf[0].groups.split('гр.')[0] : 'Факультет'}</p>
                                <p>{StudentInf && StudentInf.length > 0 ? this.state.id_rate + '-курс' : 'Курс'}</p>
                                <p>{StudentInf && StudentInf.length > 0 ? StudentInf[0].groups.split('гр.')[1] : 'Группа'}</p>
                                <p>{StudentInf && StudentInf.length > 0 ? StudentInf[0].idid : 'ID'}</p>
                            </div>
                            {this.props.selected_menu === 3 ?
                                <button className='Button' onClick={() => this.OpenSpravka(1)}>
                                    <i className="fas fa-file-alt"></i>
                                    <p>Перейти на справку</p>
                                </button> :
                                <button className='Button' onClick={() => this.OpenSpravka(1)}>
                                    <i className="fas fa-file-alt"></i>
                                    <p>Справка</p>
                                </button>
                            }

                            <span />
                        </div>
                        {/* Окно редактирования "Справка" */}
                        {
                            this.props.spravka === 1 ?
                                <div className='Spravka_bgrnd'>
                                    <div className='Spravka_container'>
                                        {this.state.warning_raion === 1 ?
                                            <div className="warning_raion">
                                                <p>Выберите район</p>
                                                <button onClick={() => this.warning(0)}>Oк</button>
                                            </div> : null}
                                        <div className='Primechanie_header'>
                                            <h3>Справка</h3>
                                            <i className="fas fa-times" onClick={() => this.OpenSpravka(0)}></i>
                                        </div>
                                        <div className='Spravka_left_side'>
                                            <div className='Spravka_person'
                                                style={{ border: this.props.id_student > 0 ? 'none' : '1px solid #2F80ED' }}>
                                                {this.props.id_student > 0 ?
                                                    photo && photo.length > 0 ? <img src={`data:image/jpeg;base64,${photo}`} alt='Avatar' /> :
                                                        <i className="fas fa-user-graduate"></i> : null
                                                }
                                            </div>
                                            <button onClick={() => this.OpenReportsPage(1, 1)}>
                                                <i className="far fa-file-alt"></i>
                                                Обходной лист
                                            </button>
                                            {this.props.Male ? <button onClick={() => this.OpenReportsPage(1, 2)}>
                                                <i className="far fa-file-alt"></i>
                                                Военкомат
                                            </button> : null}
                                            <button onClick={() => this.OpenReportsPage(1, 3)}>
                                                <i className="far fa-file-alt"></i>
                                                Соцфонд
                                            </button>
                                        </div>
                                        <div className='Spravka_right_side'>
                                            <div>
                                                <h3>ФИО</h3>
                                                <h4>{StudentInf && StudentInf.length > 0 ? StudentInf[0].s_fio : 'ФИО'}</h4>
                                            </div>
                                            <div>
                                                <h3>Курс</h3>
                                                <h4>{StudentInf && StudentInf.length > 0 ? this.state.id_rate + '-курс' : 'Курс'}</h4>

                                            </div>
                                            <div>
                                                <h3>Группа</h3>
                                                <h4>{StudentInf && StudentInf.length > 0 ? StudentInf[0].groups.split('гр.')[1] : 'Группа'}</h4>
                                            </div>
                                            <div>
                                                <h3>Страна</h3>
                                                <select onChange={this.props.SelectRepublic}>
                                                    {Republics && Republics !== null ? Republics.map((item, index) => (
                                                        <option key={'republic' + index} value={item.id_republics}>{item.visible === true && item.republic}</option>
                                                    )) : null}
                                                </select>
                                            </div>
                                            <div>
                                                <h3>Область</h3>
                                                <select onChange={this.props.SelectOblast}>
                                                    <option className={{ color: 'red' }}>Выберите область</option>
                                                    {OblastList && OblastList !== null ? OblastList.map((item, index) => (
                                                        <option key={'oblast' + index} value={item.id_oblast}>{item.oblast}</option>
                                                    )) : null}
                                                </select>
                                            </div>
                                            <div className='raion'>
                                                <h3>Район</h3>
                                                <div style={{ gridTemplateColumns: this.props.id_oblast > 0 ? '1fr 30px' : '1fr' }}>
                                                    <select onChange={this.props.SelectRaion}>
                                                        {RaionList && RaionList !== null ? RaionList.map((item, index) => (
                                                            <option key={'raion' + index} value={item.id_raion}>{item.raion}</option>
                                                        )) : null}
                                                    </select>
                                                    {this.props.id_oblast > 0 ?
                                                        <button className='insert_raion' onClick={() => this.openRedactWindowRaion(1)}>
                                                            <i className="fas fa-plus"></i>
                                                        </button> : null
                                                    }

                                                </div>
                                            </div>
                                            <div className='Study_period'>
                                                <h3>Период обучения</h3>
                                                <label>
                                                    c
                                                    <input type='number'
                                                        onChange={this.props.onChangeStartYear}
                                                        min={(2000 + (this.props.id_a_year) - (+this.props.id_rate) + 1)}
                                                        max={(2000 + this.props.id_a_year + 1)}
                                                        defaultValue={this.props.startYear} required />
                                                    по
                                                    <input type='number'
                                                        onChange={this.props.onChangeEndYear}
                                                        min={(this.props.startYear)}
                                                        max={(2000 + (this.props.id_a_year) - (+this.props.id_rate) + 10)}
                                                        defaultValue={this.props.endYear} required />
                                                    гг.
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div> : null
                        }
                        {
                            this.state.redactRaion === 1 ?
                                <div className=' Spravka_bgrnd'>
                                    <div className='redactRaion Spravka_container'>
                                        <div className='Primechanie_header'>
                                            <h3>Окно редактирования</h3>
                                            <i className="fas fa-times" onClick={() => this.openRedactWindowRaion(0)}></i>
                                        </div>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        №
                                                    </th>
                                                    <th>
                                                        Районы
                                                    </th>
                                                    <th>
                                                        Райондор
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {RaionList && RaionList !== null ? RaionList.map((item, index) => (
                                                    <tr key={'raion_redact' + index}>
                                                        <td>{index + 1}</td>
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                            {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                <input
                                                                    onChange={this.onChangeRaion}
                                                                    defaultValue={item.raion}
                                                                /> : item.raion
                                                            }
                                                        </td>
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                            {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                <input
                                                                    onChange={this.onChangeRaionKg}
                                                                    defaultValue={item.raion_kg}
                                                                /> : item.raion_kg
                                                            }
                                                        </td>
                                                        <td style={{ width: '100px' }}>
                                                            {
                                                                newRaion && newRaionKg && this.state.activerow_ind === index ?
                                                                    <i className="fas fa-save" onClick={() => this.SaveUpdatedRaion(index, item.id_raion)}></i> : null
                                                            }
                                                            {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                <i class="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> : <>
                                                                    <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                                    <i class="far fa-trash-alt" onClick={() => this.sureDelete(index + 'raion')}></i> </>}
                                                        </td>

                                                        {
                                                            this.state.SureDel === index + 'raion' &&
                                                            <div className="Delet_Sure">
                                                                <p>
                                                                    <span>Вы действительно хотите удалить район-</span>
                                                                    "{item.raion}"
                                                                </p>
                                                                <label
                                                                    className="save_button"
                                                                    onClick={() =>
                                                                        this.SureDeleteRaion(item.id_raion)
                                                                    }
                                                                >
                                                                    <i className="fas fa-trash-alt"> </i>Удалить
                                                                </label>
                                                                <label
                                                                    className="cancel_button"
                                                                    onClick={() => this.sureDelete(-1)}
                                                                >
                                                                    <i className="fas fa-ban"></i>Отмена
                                                                </label>
                                                            </div>
                                                        }

                                                    </tr>
                                                )) : null
                                                }
                                                <tr>
                                                    <td><i className="fas fa-plus" onClick={() => this.plusInsertRow(1)}></i></td>
                                                    {this.state.plusraion === 1 &&
                                                        <td>
                                                            <input
                                                                onChange={this.onChangeRaion}
                                                            />
                                                        </td>}
                                                    {this.state.plusraion === 1 &&
                                                        <td>
                                                            <input
                                                                onChange={this.onChangeRaionKg}
                                                            />
                                                        </td>}
                                                    {this.state.plusraion === 1 &&
                                                        <td>
                                                            {newRaion && newRaionKg ?
                                                                <i className="fas fa-save" onClick={() => this.SaveInsertedRaion()}></i> : null}
                                                            <i class="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                                        </td>}


                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div> : null
                        }

                        <div className={this.props.id_student > 0 ? 'Dolgi' : 'Dolgi Notactive'}>
                            <h3 style={{ marginBottom: '10px' }}>Есть долги за:</h3>
                            <form onSubmit={this.handleFormSubmit}>
                                {this.createCheckboxes()}
                                <div className='Dolgi_buttons'>
                                    <button className='Button' type='button' onClick={() => this.OpenPrimechanie(1)}>
                                        <i className="fas fa-tags"></i>
                                        <p>Примечания</p>
                                    </button>
                                    {this.state.Checkbox_clicked &&
                                        <button className='Button' type="submit">
                                            <i className="fas fa-save"></i>
                                            <p>Сохранить</p>
                                        </button>
                                    }
                                </div>
                            </form>
                            <span />
                        </div>
                        <div className="Descriptions">
                            {PAYMENT.length && PAYMENT[0].map(a => a.dolg)?.reduce(function (a, b) { return a + parseInt(b) }) > 0 ?
                                <div className="Descriptions_dolg" >
                                    <p style={{ textAlign: 'left' }}>1.   Долги за обучение:</p>
                                    <div> {PAYMENT[0].map(a => (<b>{a.dolg > 0 && a.id_rate + '-курс: ' + a.dolg + ' сом; '}</b>))}</div>
                                </div> : null}

                            {Description && Description !== null ? Description.map((item, index) => (

                                this.props.id_AVN_User === item.id_user ? <div key={"Descriptions" + index} className="Descriptions_row" >
                                    <p>{index + (PAYMENT.length && PAYMENT[0].map(a => a.dolg)?.reduce(function (a, b) { return a + parseInt(b) }) > 0) ? 2 : 1}</p>
                                    <p style={{ textAlign: 'left' }}>{item.okno_description}</p>
                                    <i className="fas fa-edit" title="Изменить" onClick={() => this.OpenUpdateWindow(index)}></i>
                                    <i className="far fa-trash-alt" title="Удалить" onClick={() => this.sureDelete(index)}></i>
                                    {/* Окно подтверждения "Удалить" */}
                                    {
                                        this.state.SureDel === index &&
                                        <div className="Delet_Sure">
                                            <p>
                                                <span>Вы действительно хотите удалить примечание-</span>
                                                "{item.okno_description}"
                                            </p>
                                            <label
                                                className="save_button"
                                                onClick={() =>
                                                    this.postDescriptionDelete(item.id_okno_description)
                                                }
                                            >
                                                <i className="fas fa-trash-alt"> </i>Удалить
                                            </label>
                                            <label
                                                className="cancel_button"
                                                onClick={() => this.sureDelete(-1)}
                                            >
                                                <i className="fas fa-ban"></i>Отмена
                                            </label>
                                        </div>
                                    }
                                    {/* Окно редактирования "Примечание" */}
                                    {
                                        this.state.updateWindow === index ?
                                            <div className='Primechanie_bgrnd'>
                                                <div className='Primechanie_container'>
                                                    <div className='Primechanie_header'>
                                                        <h3>Примечание</h3>
                                                        <i className="fas fa-times" onClick={() => this.OpenUpdateWindow(-1)}></i>
                                                    </div>
                                                    <div className='Primechanie_input_container'>
                                                        <textarea onChange={this.props.onChangeDescription} type="text"
                                                            defaultValue={item.okno_description} />
                                                    </div>
                                                    {!this.props.newDescription ?
                                                        <button className='Button Cancel' onClick={() => this.OpenUpdateWindow(-1)}>
                                                            <i className="fas fa-ban"></i>
                                                            <p >Отмена</p>
                                                        </button> :
                                                        <button className='Button' onClick={() => this.postDescriptionUpdate(item.id_okno_description)}>
                                                            <i className="fas fa-save"></i>
                                                            <p >Сохранить</p>
                                                        </button>}
                                                </div>
                                            </div> : null
                                    }
                                </div> : <div key={"description" + index} className="Descriptions_row Not_Active" style={{ color: ('#' + item.id_user + '5c') }}>
                                    <p>{index + 1 + '.'}</p>
                                    <p style={{ textAlign: 'left' }}>{item.okno_description}</p>
                                </div>
                            )) : null}

                        </div>
                        {/* Окно добавления "Примечание" */}
                        {
                            this.state.primechanie === 1 ?
                                <div className='Primechanie_bgrnd'>
                                    <div className='Primechanie_container'>
                                        <div className='Primechanie_header'>
                                            <h3>Примечание</h3>
                                            <i className="fas fa-times" onClick={() => this.OpenPrimechanie(0)}></i>
                                        </div>
                                        <div className='Primechanie_input_container'>
                                            <textarea onChange={this.props.onChangeDescription} type="text" />
                                        </div>
                                        {!this.props.newDescription ?
                                            <button className='Button Cancel' onClick={() => this.OpenPrimechanie(0)}>
                                                <i className="fas fa-ban"></i>
                                                <p >Отмена</p>
                                            </button> :
                                            <button className='Button' onClick={() => this.postDescriptionInsert()}>
                                                <i className="fas fa-save"></i>
                                                <p >Сохранить</p>
                                            </button>}
                                    </div>
                                </div> : null
                        }
                    </div > :
                    // сотрудник_сотрудник_сотрудник_сотрудник_сотрудник_сотрудник_сотрудник_сотрудник_сотрудник

                    <div className="Right_side_container">
                        <div className={this.props.id_teacher > 0 ? 'About_person' : 'About_person Notactive'}>
                            <div className='Ava_person'
                                style={{ border: this.props.id_teacher > 0 ? 'none' : '1px solid #2F80ED' }}>
                                {this.props.id_teacher > 0 ?
                                    teacherPhoto && teacherPhoto.length > 0 ? <img src={`data:image/jpeg;base64,${teacherPhoto}`} alt='Avatar' /> :
                                        <i className="fas fa-user"></i> : null
                                }
                            </div>
                            <div className='Fio_person'>
                                <h3>{this.props.s_t_fio !== '' ? this.props.s_t_fio : 'ФИО'}</h3>
                                <p>{'Кафедра'}</p>
                                <p>{'Должность'}</p>
                            </div>
                            <button className='Button' onClick={() => this.OpenReportsPage(1, 'teacherReport')}>
                                <i className="fas fa-file-alt"></i>
                                <p>Справка </p>
                            </button>
                            <span />
                        </div>
                        {/* Окно редактирования "Справка" */}


                        <div className={this.props.id_teacher > 0 ? 'Dolgi' : 'Dolgi Notactive'}>
                            <h3 style={{ marginBottom: '10px' }}>Есть долги за:</h3>
                            <form onSubmit={this.handleFormSubmitTeacher}>
                                {this.createCheckboxesTeacher()}
                                <div className='Dolgi_buttons'>
                                    <button className='Button' type='button' onClick={() => this.OpenPrimechanie(1)}>
                                        <i className="fas fa-tags"></i>
                                        <p>Примечания</p>
                                    </button>
                                    {this.state.Checkbox_clicked &&
                                        <button className='Button' type="submit">
                                            <i className="fas fa-save"></i>
                                            <p>Сохранить</p>
                                        </button>}
                                </div>
                            </form>
                            <span />
                        </div>
                        <div className="Descriptions">
                            {DescriptionTeacher && DescriptionTeacher !== null ? DescriptionTeacher.map((item, index) => (

                                this.props.id_AVN_User === item.id_user ? <div div key={"Descriptions" + index} className="Descriptions_row" >
                                    <p>{index + 1 + '.'}</p>
                                    <p style={{ textAlign: 'left' }}>{item.okno_description}</p>
                                    <i className="fas fa-edit" title="Изменить" onClick={() => this.OpenUpdateWindow(index)}></i>
                                    <i className="far fa-trash-alt" title="Удалить" onClick={() => this.sureDelete(index)}></i>
                                    {/* Окно подтверждения "Удалить" */}
                                    {
                                        this.state.SureDel === index &&
                                        <div className="Delet_Sure">
                                            <p>
                                                <span>Вы действительно хотите удалить примечание-</span>
                                                "{item.okno_description}"
                                            </p>
                                            <label
                                                className="save_button"
                                                onClick={() =>
                                                    this.postDescriptionTeacherDelete(item.id_okno_description_teacher)
                                                }
                                            >
                                                <i className="fas fa-trash-alt"> </i>Удалить
                                            </label>
                                            <label
                                                className="cancel_button"
                                                onClick={() => this.sureDelete(-1)}
                                            >
                                                <i className="fas fa-ban"></i>Отмена
                                            </label>
                                        </div>
                                    }
                                    {/* Окно редактирования "Примечание" */}
                                    {
                                        this.state.updateWindow === index ?
                                            <div className='Primechanie_bgrnd'>
                                                <div className='Primechanie_container'>
                                                    <div className='Primechanie_header'>
                                                        <h3>Примечание</h3>
                                                        <i className="fas fa-times" onClick={() => this.OpenUpdateWindow(-1)}></i>
                                                    </div>
                                                    <div className='Primechanie_input_container'>
                                                        <textarea onChange={this.props.onChangeDescriptionTeacher} type="text"
                                                            defaultValue={item.okno_description} />
                                                    </div>
                                                    {!this.props.newDescriptionTeacher ?
                                                        <button className='Button Cancel' onClick={() => this.OpenUpdateWindow(-1)} >
                                                            <i className="fas fa-ban"></i>
                                                            <p>Отмена</p>
                                                        </button> :
                                                        <button className='Button'>
                                                            <i className="fas fa-save"></i>
                                                            <p onClick={() => this.postDescriptionTeacherUpdate(item.id_okno_description_teacher)}>Сохранить</p>
                                                        </button>}
                                                </div>
                                            </div> : null
                                    }
                                </div> : <div key={"description" + index} className="Descriptions_row Not_Active" style={{ color: ('#' + item.id_user + '5c') }}>
                                    <p>{index + 1 + '.'}</p>
                                    <p style={{ textAlign: 'left' }}>{item.okno_description}</p>
                                </div>
                            )) : null}

                        </div>
                        {/* Окно добавления "Примечание" */}
                        {
                            this.state.primechanie === 1 ?
                                <div className='Primechanie_bgrnd'>
                                    <div className='Primechanie_container'>
                                        <div className='Primechanie_header'>
                                            <h3>Примечание</h3>
                                            <i className="fas fa-times" onClick={() => this.OpenPrimechanie(0)}></i>
                                        </div>
                                        <div className='Primechanie_input_container'>
                                            <textarea onChange={this.props.onChangeDescriptionTeacher} type="text" />
                                        </div>
                                        {!this.props.newDescriptionTeacher ? <button className='Button Cancel'>
                                            <i className="fas fa-ban"></i>
                                            <p onClick={() => this.OpenUpdateWindow(-1)}>Отмена</p>
                                        </button> :
                                            <button className='Button'>
                                                <i className="fas fa-save"></i>
                                                <p onClick={() => this.postDescriptionTeacherInsert()}>Сохранить</p>
                                            </button>}
                                    </div>
                                </div> : null
                        }
                    </div >


            )
    }
}
